<template>
  <div id="tld-create" class="row">
    <form id="create-tld-form" class="small-12 medium-5 columns" @submit.prevent="submitForm">
      <label>
        {{ 'TLD'|t }}
        <input type="text" ref="tld" v-model="tld" pattern=".{2,64}" required="required" autofocus />
      </label>

      <label>
        {{ 'Registrant country code'|t }}
        <input type="text" v-model="regcc" pattern=".{0}|.{2}" maxlength="2" />
      </label>

      <label for="price">{{ 'Price'|t }}</label>
      <div class="input-group">
        <input class="input-group-field" id="price" type="number" min="0" v-model="price" required="required" />
        <span class="input-group-label">{{ 'credits'|t }}</span>
      </div>

      <fieldset class="fieldset">
        <legend>{{ 'Domain length'|t }}</legend>
        <div class="collapse row">
          <div class="small-5 columns">
            <label>
              {{ 'Minimum length'|t }}
              <input type="number" min="0" v-model="domlenmin" required="required" />
            </label>
          </div>
          <div class="small-2 columns"></div>
          <div class="small-5 columns">
            <label>
              {{ 'Maximum length'|t }}
              <input type="number" min="0" v-model="domlenmax" required="required" />
            </label>
          </div>
        </div>
      </fieldset>

      <fieldset class="fieldset">
        <legend>{{ 'Periods'|t }}</legend>
        <div class="row">
          <div class="small-6 columns">
            <label><input type="checkbox" v-model="periods" value="1" /> 1 year</label>
            <label><input type="checkbox" v-model="periods" value="2" /> 2 years</label>
            <label><input type="checkbox" v-model="periods" value="3" /> 3 years</label>
            <label><input type="checkbox" v-model="periods" value="4" /> 4 years</label>
            <label><input type="checkbox" v-model="periods" value="5" /> 5 years</label>
          </div>
          <div class="small-6 columns">
            <label><input type="checkbox" v-model="periods" value="6" /> 6 years</label>
            <label><input type="checkbox" v-model="periods" value="7" /> 7 years</label>
            <label><input type="checkbox" v-model="periods" value="8" /> 8 years</label>
            <label><input type="checkbox" v-model="periods" value="9" /> 9 years</label>
            <label><input type="checkbox" v-model="periods" value="10" /> 10 years</label>
          </div>
        </div>

        <label for="pertrans">{{ 'Transfer period'|t }}</label>
        <div class="input-group">
          <input class="input-group-field" id="pertrans" type="number" min="0" v-model="pertrans" required="required" />
          <span class="input-group-label">{{ 'days'|t }}</span>
        </div>

        <label for="arp">{{ 'Auto-renew period'|t }}</label>
        <div class="input-group">
          <input class="input-group-field" type="number" min="0" id="arp" v-model="arp" required="required" />
          <span class="input-group-label">{{ 'days'|t }}</span>
        </div>

        <label for="rgp">{{ 'Redemption Grace Period'|t }}</label>
        <div class="input-group">
          <input class="input-group-field" id="rgp" type="number" min="0" v-model="rgp" required="required" />
          <span class="input-group-label">{{ 'days'|t }}</span>
        </div>

        <label for="pdp">{{ 'Pending delete period'|t }}</label>
        <div class="input-group">
          <input class="input-group-field" id="pdp" type="number" min="0" v-model="pdp" required="required" />
          <span class="input-group-label">{{ 'days'|t }}</span>
        </div>

        <label for="arp">{{ 'Add grace period'|t }}</label>
        <div class="input-group">
          <input class="input-group-field" type="number" min="0" id="agp" v-model="agp" />
          <span class="input-group-label">{{ 'days'|t }}</span>
        </div>

        <label for="arp">{{ 'Transfer grace period'|t }}</label>
        <div class="input-group">
          <input class="input-group-field" type="number" min="0" id="tgp" v-model="tgp" />
          <span class="input-group-label">{{ 'days'|t }}</span>
        </div>

        <label for="tpp">{{ 'Prohibited transfer period'|t }}</label>
        <div class="input-group">
          <input class="input-group-field" type="number" min="0" id="tpp" v-model="tpp" />
          <span class="input-group-label">{{ 'days'|t }}</span>
        </div>

      </fieldset>

      <label>
        {{ 'Nameservers'|t }}
        <textarea v-model="nameservers" rows="5"></textarea>
      </label>

      <fieldset class="fieldset">
        <legend>{{ 'Options'|t }}</legend>

        <label>
          <input type="checkbox" v-model="idnok" />
          {{ 'Allow IDN'|t }}
        </label>

        <label>
          <input type="checkbox" v-model="plain_transfer" />
          {{ 'Allow plain transfer without renewal'|t }}
        </label>

        <label>
          <input type="checkbox" v-model="idnumreq" />
          {{ 'Require IDNum'|t }}
        </label>

        <label>
          <input type="checkbox" v-model="vatreq" />
          {{ 'Require VAT'|t }}
        </label>

        <label>
          <input type="checkbox" v-model="birthreq" />
          {{ 'Require date of birth'|t }}
        </label>

        <label>
          <input type="checkbox" v-model="confirm" />
          {{ 'Require confirmation'|t }}
        </label>

        <label>
          <input type="checkbox" v-model="nsreq" />
          {{ 'Require name servers'|t }}
        </label>

        <label>
          <input type="checkbox" v-model="reat" />
          {{ 'Reset expiration date after transfer'|t }}
        </label>
      </fieldset>

      <label>
        {{ 'IDN tables'|t }}
        <textarea v-model="idn_tables" rows="5"></textarea>
      </label>

      <fieldset>
        <legend>{{ 'Expiration policy'|t }}</legend>
        <div class="collapse row">
          <div class="small-6 columns">
            <label><input type="radio" v-model="exp" value="autorenew" required="required" name="exp" /> Auto-renew</label>
          </div>
          <div class="small-6 columns">
            <label><input type="radio" v-model="exp" value="rgp" required="required" name="exp" /> RGP</label>
          </div>
        </div>
      </fieldset>

      <input type="submit" name="submit" :value="'Submit'|t" class="medium expanded success button" />
    </form>
  </div>
</template>

<script>
  import api from '@/api';
  import router from '@/routes';

  export default {
    name: 'CreateForm',
    data() {
      return {
        tld: "",
        price: 10,
        domlenmin: 2,
        domlenmax: 64,
        periods: [1],
        pertrans: 30,
        idnok: false,
        regcc: "",
        idnumreq: false,
        vatreq: false,
        birthreq: false,
        confirm: false,
        arp: 30,
        rgp: 30,
        pdp: 30,
        exp: 'autorenew',
        nsreq: true,
        plain_transfer: false,
        nameservers: "",
        agp: 0,
        tgp: 0,
        idn_tables: "",
        tpp: 0,
        reat: false,
      }
    },
    methods: {
      submitForm() {
        let request = {
          tld: this.tld.toLocaleLowerCase(),
          price: parseInt(this.price),
          domain_length_min: parseInt(this.domlenmin),
          domain_length_max: parseInt(this.domlenmax),
          period: [],
          period_transfer: parseInt(this.pertrans),
          idn_allowed: this.idnok === true,
          registrant_cc: this.regcc.toUpperCase(),
          idnum_required: this.idnumreq === true,
          vat_required: this.vatreq === true,
          birthdate_required: this.birthreq === true,
          confirmation: this.confirm === true,
          auto_renew_period: parseInt(this.arp),
          rgp_period: parseInt(this.rgp),
          pending_delete_period: parseInt(this.pdp),
          expiration_policy: this.exp,
          ns_required: this.nsreq === true,
          plain_transfer: this.plain_transfer === true,
          nameservers: this.nameservers.split("\n").filter(word => word.length > 0),
          add_grace_period: this.agp,
          transfer_grace_period: this.tgp,
          idn_tables: this.idn_tables.split("\n").filter(word => word.length > 0),
          transfer_prohibited_period: parseInt(this.tpp),
          reset_expiration_after_transfer: this.reat === true,
        };

        this.periods.forEach(function(value) {
          request.period.push(parseInt(value));
        });

        api.createTLD(
          request,
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "TLD %s has been created.",
              args: [data.tld]
            }, {root: true});
            router.push({name: 'tld.collection'});
          }
        )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/tld/CreateForm.vue